<template>
    <ui-modal :class="{ 'has-right-aside': layout.showAside }"
        :loadSuccess="loader.modalLoadSuccess"
        :load="loader.loadModal"
        name="marketing-integrations-facebook-create-integration"
        title="Criar nova integração"
        icon="fal fa-plug"
        size="sm">
        <template #right>
            <div v-show="layout.showAside" :class="{ 'show': layout.showAside }" class="aside">
                <div class="aside-header">
                    <div>
                        <i class="fal fa-handshake" />
                        <span>Formulários</span>
                    </div>

                    <button class="button-close" type="button" @click="hideModal">
                        <i class="fas fa-times" aria-hidden="true" />
                    </button>
                </div>

                <div class="aside-content">
                    <div class="status-bar">
                        <div v-if="qtdFormsComputed" class="form-count">
                            Existe<template v-if="qtdFormsComputed > 1">m</template>
                            <span class="text-info"> {{ qtdFormsComputed }}</span>
                            formulario<template v-if="qtdFormsComputed > 1">s</template>
                            em <span class="text-info">{{ infoForm }}</span>
                        </div>

                        <div v-else class="form-count">Não existe nenhum formulário</div>

                        <ui-select v-model="filterPerFormStatusComputed"
                            size= 'md'
                            label="Status:"
                            text-default="Selecionar">
                            <option v-for="(status, index) in states"
                                :key="index"
                                :value="status.value">
                                {{ status.name }}
                            </option>
                        </ui-select>

                        <div class="searche-box-input">
                            <ui-search-box class="search-box" event="marketing-integrations-facebook-form-search" />
                        </div>
                    </div>

                    <div class="select-facebook-form">
                        <ui-select-facebook-form :value="pageForms"
                            :showFormWithoutIntegration="layout.showFormWithoutIntegration"
                            :load="loader.itemsAside"
                            @selected-form="formSelectHandler" />
                    </div>

                    <ui-configuration-modal v-if="selectedAccountComputed && pageSelected && formSelected"
                        :user="userComputed"
                        @integration-success="savedConfigHandler" />
                </div>

                <div class="aside-footer">
                    <ui-pagination v-if="currentFormPage > 1"
                        :next="nextFormPagingStatusComputed"
                        :current="currentFormPage"
                        @next="nextPageForms"
                        @previous="previousPageForms" />
                </div>
            </div>
        </template>

        <div :class="{ 'has-right-aside': layout.showAside }" class="modal">
            <div class="modal-body"> 
                <div v-if="loader.items" class="load-indicator">
                    <ui-load-indicator :h="50" :stroke="8" bgColor="#e7e9f4" color="#69D296" />
                </div>

                <form class="form" v-else>
                    <ui-overlay-load v-if="loader.editingForm" />

                    <ui-select v-model="selectedAccountComputed"
                        :showDefault="true"
                        size="lg"
                        @input="accountSelectHandler">
                        <option v-for="(account, index) in accountOptions"
                            :key="index"
                            :value="index">
                            Conta Facebook: {{ account.name }}
                        </option>
                    </ui-select>
                    
                    <div v-if="setSelect && selectedAccountComputed" class="select-facebook-integration">
                        <ui-select-facebook-integration :value="accountPages"
                            :load="loader.selectFacebookUser"
                            @input="pageSelectHandler" 
                            @loadPages="loadPages"
                            />
                    </div>
                </form>
            </div>

            <div class="modal-footer">
                <ui-switch
                    class="actions"
                    v-show="layout.showAside"
                    :checked="layout.showFormWithoutIntegration"
                    id="marketing-integrations-facebook-create-integration-form-without-integration"
                    label="Mostrar apenas formulários sem integração"
                    name="form-without-integration"
                    design="xs primary"
                    @input="formWithoutIntegrationHandler" />
            </div>
        </div>
    </ui-modal>
</template>

<script>
    import { uiModal } from "@/components/ui/modal"
    import { uiSelect, uiSwitch } from '@/components/ui/form'
    import { uiButton } from '@/components/ui/buttons'
    import { uiOverlayLoad, uiLoadIndicator, uiPagination, uiSearchBox } from '@/components/ui'
    import uiSelectFacebookForm from '@/components/ui-facilita/marketing/select-facebook-form'
    import uiSelectFacebookIntegration from '@/components/ui-facilita/marketing/select-facebook-integration'
    import uiConfigurationModal from '../configuration-modal'

    import { facebook, facebookAccounts } from '@/services/axios'

    import store from '@/store'
    import { mapGetters } from 'vuex'

    const defaultLayout = () => {
        return {
            showFormWithoutIntegration: false,
            showAside: false,
        }
    }

    const defaultLoader = () => {
        return {
            loadModal: false,
            modalLoadSuccess: false,
            editingForm: false,
            items: true,
            itemsAside: true,
        }
    }

    export default {
        name: 'ui-modal-itegrations-facebook',
        components: {
            uiModal,
            uiSelect,
            uiSwitch,
            uiOverlayLoad,
            uiLoadIndicator,
            uiSelectFacebookForm,
            uiSelectFacebookIntegration,
            uiConfigurationModal,
            uiPagination,
            uiSearchBox,
            uiButton
        },

        data() {
            return {
                layout: {
                    showFormWithoutIntegration: false,
                    showAside: false,
                },
                loader: {
                    loadModal: false,
                    modalLoadSuccess: false,
                    selectFacebookUser: false,
                    editingForm: false,
                    items: true,
                    itemsAside: true,
                },
                infoForm: '',
                accountSelectParams: {
                    page: 1,
                    perPage: '*',
                },
                accountOptions: [],
                accountPages: [],
                pageForms: [],
                qtdForms: 0,
                currentFormPage: 1,
                pageFormsPaging: {},
                statusFormFilter: null,
                setSelect: false,
                valueSearchForm: '',
                nextPages: {
                    hasNext: true,
                    next: null
                },
                wait: false,
                account: null,
                data: [],
                states: [
                    { value: 'ACTIVE', name: 'Ativos' },
                    { value: 'ARCHIVED', name: 'Arquivados' },
                    // { value: 'DELETED', name: 'Deletados' },
                    // { value: 'DRAFT', name: 'Lixeira' },
                ]
            }
        },

        watch: {
            filterPerFormStatusComputed(newValue) {
                if (this.valueSearchForm) {
                    this.loadPageForms(newValue, null, this.valueSearchForm)
                } else {
                    this.loadPageForms(newValue)
                }
            },
        },

        computed: {
            ...mapGetters('facebook', {
                accountSelected: 'getConfigurationAccount',
                pageSelected: 'getConfigurationPage',
                formSelected: 'getConfigurationForm',
            }),
            userComputed() {
                return store.getters.user
            },
            selectedAccountComputed: {
                get() {
                    return this.accountSelected
                },
                set(newIndex) {
                    this.$store.dispatch('facebook/setConfigurationAccount', this.accountOptions[newIndex])
                }
            },
            qtdFormsComputed() {
                this.$root.$emit('has-form', this.pageForms.length)
                return this.pageForms && this.pageForms.length ? this.pageForms.length  : 0
            },
            /**
             * Computed property que define se existe uma próxima página na listagem de formulários
             */
            nextFormPagingStatusComputed() {
                return this.pageFormsPaging && this.pageFormsPaging.next ? true : false
            },
            filterPerFormStatusComputed: {
                get() {
                    return this.statusFormFilter
                },
                set(value) {
                    this.currentFormPage = 1
                    this.statusFormFilter = value
                }
            }
        },

        mounted() {
            /**
             * Ao Abrir o modal pela primeira vez, envia-se um objeto como parametro
             * para ocultar o botão de cancelar.
             */
            this.$root.$on('modal-open-marketing-integrations-facebook-create-integration', () => {
                this.resetLayout()
                this.resetLoader()
                this.loadItems()
                this.setDefaultData()
                this.setSelect = false
            })

            /**
             * Pesquisar formulários por nome ou id
             */
            this.$root.$on('marketing-integrations-facebook-form-search', (event) => {
                this.searchPageForm(event)
			})
        },

        methods: {
            /**
             * Reseta a conta selecionada
             */
            setDefaultData() {
                this.selectedAccountComputed = 0
                this.$store.dispatch('facebook/setConfigurationForm', null)
                this.$store.dispatch('facebook/setConfigurationPage', null)
            },
            savedConfigHandler() {
                this.setFormsStatus()
            },
            /**
             * Reseta o layout
             */
            resetLayout() {
                this.layout = defaultLayout()
            },
            /**
             * Reseta os loadings
             */
            resetLoader() {
                this.loader = {...defaultLoader()}
            },
            /**
             * Reseta os filtros
             */
            resetFilters() {
                this.filterPerFormStatusComputed = null
                this.$root.$emit('marketing-integrations-facebook-form-search')
            },
            /**
             * Carrega todos os itens que serão listados no select. Durante o carregamento mostra
             * o load e depois esconde o load mostrando o modal
             */
            loadItems() {
                facebookAccounts.dataTable(this.accountSelectParams)
                    .then(response => {
                        this.accountOptions = [...response.data.data]
                    })
                    .catch(error => {
                        console.log(error)
                    })
                    .finally(() => {
                        this.$set(this.loader, 'items', false)
                    })
            },
            /**
             * Carrega todos os itens que serão listados na selec do ASIDE/Lateral
             * Duante o carregamento mosra o load e após esconde o load mostrando o modal
             */
            loadItemsAside() {
                setTimeout(() => {
                    this.$set(this.loader, 'itemsAside', false)
                }, 404)
            },
            /**
             * Evento dispara ao alerar o estado do Switch
             * Altera os itens listados na select
             */
            formWithoutIntegrationHandler(value) {
                this.$set(this.layout, 'showFormWithoutIntegration', value)
            },
            /**
             * Fecha o modal lateral de lisagem de formulários
             */
            closeAside() {
                setTimeout(async () => {
                    this.$set(this.layout, 'showAside', false)
                    await this.$store.dispatch('facebook/setStatusAside', false)
                    this.resetFilters()
                }, 400)
            },
            /**
             * Fecha o modal lateral de lisagem de formulários
             */
            openAside() {
                this.$set(this.layout, 'showAside', true)
            },
            /**
             * Abre / Mostra o modal de configurações do formulário
             */
            showConfigurationModal() {
                this.$root.$emit('modal-open-marketing-integrations-facebook-create-integration-configuration')
            },
            /**
             * Fecha / modal de configurações do formulário
             */
            hideConfigurationModal() {
                this.$root.$emit('modal-close-marketing-integrations-facebook-create-integration-configuration')
            },
            /**
             * Fecha / modal de configurações do formulário
             */
            hideModal() {
                this.$root.$emit('modal-close-marketing-integrations-facebook-create-integration')
                this.$emit('close')
                this.closeAside()
            },
            /**
             * Evento é disparado ao clicar no botão de Integração dentro da select de formulários
             */
            formSelectHandler: async function (event) {
                await this.$store.dispatch('facebook/setConfigurationForm', event)
                this.showConfigurationModal()
            },
            /**
             * Método chamado quando o usuário seleciona uma página
             */
            pageSelectHandler: async function (event) {
                this.infoForm = event.name
                await this.$store.dispatch('facebook/setConfigurationPage', event)
                this.resetFilters()
                this.hideConfigurationModal()
                this.openAside()
                this.loadPageForms()
            },
            /**
             * Método responsável por carregar as páginas buscando no Facebook
             */
            async loadPages(account) {
                if (!account && (!this.nextPages.hasNext || this.wait)) return 
                this.wait = true 

                if (account && (!this.account || this.account?.account_id !== account.account_id)) {
                    this.data = [] 
                    this.account = account 
                }

                if (!this.account || !this.account.account_id) {
                    this.$set(this.loader, 'selectFacebookUser', false) 
                    this.wait = false 
                    return 
                }

                let data = {
                    access_token: this.account.token,
                    limit: 25
                } 

                if (this.nextPages.hasNext && this.nextPages.next) {
                    data.after = this.nextPages.next 
                }

                this.$set(this.loader, 'selectFacebookUser', true) 

                /** A variável FB não foi declarada por vir do script de SDK do Facebook */
                // eslint-disable-next-line no-undef
                await FB.api(`/${this.account.account_id}/accounts`, data, response => {
                    if (response.data) {
                        this.data = this.data.concat(response.data) 
                        this.accountPages = this.data 
                        if (response?.paging?.next && response?.paging?.cursors?.after) {
                            this.nextPages.next = response.paging.cursors.after 
                            this.nextPages.hasNext = true 
                        } else {
                            this.nextPages.hasNext = false 
                        }

                        for (const [index, page] of this.data.entries()) {
                            this.loadPageImages(page.id, this.account.token).then(image => {
                                this.$set(this.accountPages[index], 'image', image) 
                            }) 
                        }
                    } else {
                        this.accountPages = [] 
                    }

                    this.$set(this.loader, 'selectFacebookUser', false) 
                    this.wait = false 
                }) 
            },
            /**
             * Evento disparado ao selelecionar uma conta
             */
            accountSelectHandler() {
                this.loadPages(this.selectedAccountComputed)
                this.setSelect = true
                this.closeAside()
            },
            /**
             * Carrega as imagens a partir da API do Facebook
             */
            loadPageImages: async function (pageId, accessToken) {
                let imgUrl = ''
                await new Promise(resolve => {
                    /** A variável FB não foi declarada por vir do script de SDK do Facebook */
                    // eslint-disable-next-line no-undef
                    FB.api(`/v17.0/${pageId}/picture?redirect=false`, {
                        access_token: accessToken
                    }, response => {
                        if (!response) {
                            imgUrl = false

                        } else {
                            imgUrl = response.data.url
                        }
                        resolve()
                    })
                })

                return imgUrl
            },
            /**
             * Método para carregar formulários de cada página
             */
            loadPageForms(status = null, nextPrevius = null, search = null) {
                if (!this.pageSelected) return

                let accessToken = this.pageSelected.access_token
                let requestHeader = {
                    access_token: accessToken,
                    limit: 25,
                    filtering: []
                }
                let endPoint = nextPrevius || `/${this.pageSelected.id}/leadgen_forms`

                if (status) {
                    requestHeader.filtering.push({
                        field: "status",
                        operator: "IN",
                        value: [status]
                    })
                }

                if (search && !isNaN(search)) {
                    endPoint =  `${search}`

                } else if (search) {
                    requestHeader.filtering.push({
                        field: 'name',
                        operator: 'CONTAIN',
                        value: search
                    })
                }

                this.$set(this.loader, 'itemsAside', true)
                /** A variável FB não foi declarada por vir do script de SDK do Facebook */
                // eslint-disable-next-line no-undef
                FB.api(endPoint, requestHeader, async response => {
                    if (response && !response.error) {
                        if (search && !isNaN(search)) {
                            this.pageForms = []
                            this.pageForms.push(response)
                        }

                        if (response.data) {
                            this.pageForms = [...response.data]
                            if (this.pageForms.length) this.pageFormsPaging = { ...response.paging }
                            if (!this.pageFormsPaging.previous) this.currentFormPage = 1
                        }
                        await this.setFormsStatus()

                    } else {
                        this.pageForms = []
                        this.currentFormPage = 1
                        this.pageFormsPaging = {}
                    }
                    this.$set(this.loader, 'itemsAside', false)
                })
            },
            /**
             * Método para verificar se os formulários retornados do Facebook foram configurados no Facilita
             */
            setFormsStatus() {
                return new Promise((resolve, reject) => {
                    if (!this.pageForms.length) resolve()

                    const params = {
                        forms: Object.values(this.pageForms).map(form => form.id)
                    }
                    facebook.checkIntegration(params)
                        .then(response => {
                            for (let form of this.pageForms) {
                                if (response.data && response.data.integrated.includes(form.id)) {
                                    this.$set(form, 'status_gs', 'active')

                                } else {
                                    this.$set(form, 'status_gs', 'inactive')
                                }
                            }

                            resolve()
                        })
                        .catch(error => {
                            if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
                            console.log(error)
                            reject()
                        })

                }).catch(() => {
                    this.hideModal()
                })
            },
            /**
             * Realiza uma busca por um formulário de acordo com os filtros
             */
            searchPageForm(value) {
                this.valueSearchForm = value || ''
                this.loadPageForms(this.filterPerFormStatusComputed, null, this.valueSearchForm)
            },
            /**
             * Lista a próxima página de formulários
             */
            nextPageForms() {
                if (this.pageFormsPaging.next) {
                    this.loadPageForms(this.filterPerFormStatusComputed, this.pageFormsPaging.next)
                    this.currentFormPage++
                }
            },
            /**
             * Lista a página anterior de formulários
             */
            previousPageForms() {
                if (this.pageFormsPaging.previous) {
                    this.loadPageForms(this.filterPerFormStatusComputed, this.pageFormsPaging.previous)
                    this.currentFormPage--
                }
            }
        }
    }
</script>

<style lang="stylus" scoped>
    @import './styles.styl'
</style>